import { useCallback, useState } from "react";
import pagosService from "../../../../services/pagosService";
import { showToast } from "../../../../utils/showToast";
import usePagosForm from "./usePagosForm";
import usePagosList from "./usePagosList";

export default function usePagosLogic() {
  const list = usePagosList();
  const [comprobante, setComprobante] = useState(null);
  const [comprobanteLoading, setComprobanteLoading] = useState(false);

  const form = usePagosForm({
    onCreated: () => list.reload(),
  });

  const fetchComprobante = useCallback(async (pago) => {
    const id = typeof pago === "object" ? pago?.id : pago;
    if (!id) {
      setComprobante(null);
      return null;
    }
    setComprobanteLoading(true);
    try {
      const data = await pagosService.obtenerComprobante(id);
      const safe = data || null;
      setComprobante(safe);
      return safe;
    } catch (err) {
      console.error(err);
      setComprobante(null);
      showToast({
        type: "danger",
        message: "No se pudo generar el comprobante.",
      });
      return null;
    } finally {
      setComprobanteLoading(false);
    }
  }, []);

  return {
    ...list,
    form,
    onFetchComprobante: fetchComprobante,
    comprobante,
    comprobanteLoading,
  };
}
